import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";

import HowWorksSld from "../sliders/HowWorksSld";
import HomeBanner from "./HomeBanner";
import Cards from "../cards/Cards";
import TrendingCategories from "../cards/TrendingCategories";
import AddProductPage from "../products/AddProduct";
import { getDashboard } from "../../slices/homeSlice";
import { API_BASE_URL } from "../../utils/config";
import { setGlobalLocation } from "../../slices/locationSlice";
import Loading from "../include/Loading";
import { isAuthenticated, getSignInResponse } from "../../utils/authUtil";
import SignIn from "../SignIn/SignIn";
import SignUp from "../SignIn/SignUp";
import Slider from "react-slick";
import { useNavigate } from "react-router-dom";
const Home = () => {
  const dispatch = useDispatch();
  const [cardDataSwopTown, setCardDataSwopTown] = useState([]);
  const [cardDataVehical, setcardDataVehical] = useState([]);
  const [cardDataFeatured, setCardDataFeatured] = useState([]);
  const [addproductpageopen, setAddproductpageopen] = useState('');
  const [mastercategory, setMastercategory] = useState('');
  const [cardDataSkillServices, setCardDataSkillServices] = useState([]);
  const [rootCategoryId, setRootCategoryId] = useState(1);
  const [roottype, setRootType] = useState('');
  
  const navigate = useNavigate();
  const hasChosenLocation = useSelector(
    (state) => state.location.hasChosenLocation
  );

   const settings = {
    // infinite: true,
    centerMode: false,
    dots: false,
    infinite: false,
    speed: 300,
    slidesToShow: 4.5,
    slidesToScroll: 1,
    arrows: true,
    responsive: [
      {
        breakpoint: 1024, // Adjust the breakpoint for tablets if needed
        settings: {
          slidesToShow: 3.5,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 768, // Adjust the breakpoint for smaller tablets if needed
        settings: {
          slidesToShow: 2.5,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1.4,
          slidesToScroll: 1
        }
      }
    ]
  };
  const loggedIn = isAuthenticated();
  useEffect(() => {
    if (!hasChosenLocation) {
      handleGetCurrentLocation();
    }
  }, [hasChosenLocation]);

  const globalLocation = useSelector((state) => state.location.globalLocation);

  useEffect(() => {
    dispatch(getDashboard(globalLocation));
  }, [globalLocation]);

  const dashboard = useSelector((state) => state.home.dashboard);
  const categories = useSelector((state) => state.header.categories);

  const posts_city_wise = useSelector(
    (state) => state.home.dashboard.posts_city_wise
  );
  const latest_products = useSelector(
    (state) => state.home.dashboard.latest_products
  );
  const latest_skills = useSelector(
    (state) => state.home.dashboard.latest_skills
  );
  const vehical = useSelector(
    (state) => state.home.dashboard.vehicle
  );

  useEffect(() => {
    setCardDataSwopTown(posts_city_wise);
    setCardDataFeatured(latest_products);
    setCardDataSkillServices(latest_skills);
    setcardDataVehical(vehical);
    localStorage.setItem('categoryname','');
  }, [dashboard]);

  const categorielist =(name,slug) =>{
   
    localStorage.setItem("categoryname",name);
    localStorage.setItem("categoryslug",slug);
    if (slug === "shop-exclusive") {
      localStorage.setItem("listingFilterType", "exclusiveMemberDeals");
    } else {
      localStorage.removeItem("listingFilterType");
    }
    if(slug === 'dealership'){
      var url = `/listing/automobile/${slug}`;
    } else {
      var url = `/listing/byCategory/${slug}`;
    }
   
    navigate(url);
  }
  

  const handleGetCurrentLocation = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const { latitude, longitude } = position.coords;
          fetch(
            `https://maps.googleapis.com/maps/api/geocode/json?latlng=${latitude},${longitude}&key=${process.env.REACT_APP_GOOGLE_API_KEY}`
          )
            .then((response) => response.json())
            .then((data) => {
              if (data.status === "OK") {
                if (data.results[0]) {
                  const city = data.results[0].address_components.find(
                    (component) =>
                      component.types.includes("locality") ||
                      component.types.includes("administrative_area_level_1")
                  );
                  const locationData = JSON.parse(localStorage.getItem('selectedlocation'));
                  // console.log('locationsssssssssssssssss', locationData); // Directly log the parsed object
                  
                  if (locationData) {
                    dispatch(
                      setGlobalLocation({
                        city: locationData.city, // Corrected property name
                        latitude: locationData.latitude,
                        longitude: locationData.longitude,
                      })
                    );
                  }
                   else {

                dispatch(
                  setGlobalLocation({
                    city: city.long_name,
                    latitude: latitude,
                    longitude: longitude,
                  })
                );

              }
                
                }
              } else {
                throw new Error("Failed to fetch current location");
              }
            })
            .catch((error) => {
              console.error(error);
            });
        },
        (error) => {
          console.error(error);
        }
      );
    } else {
      console.error("Geolocation is not supported by this browser");
    }
  };
  const isLoading = useSelector((state) => state.home.isLoading);
  
  return (
    <main className="sa-main-wrap">
      <Loading loading={isLoading} />
      <div className="bgtwosection">
        <div className="container">
        <div class="multi-cat-box-wrap mobile-category-wrap">
                     <ul class="list-ofmain-cat moblist-cat">
                  {categories &&
                  [...categories] // Create a shallow copy to avoid mutating the original array
                  .sort((a, b) => a.order_number - b.order_number) // Sort by order_number
                  .map((item, index) =>
                        <li key={index} onClick={() => categorielist(item.name,item.slug)}>
                           <div class="multi-box-root sub-cat-mob-js">
                              <div class="main-card-box">
                                 <i><img src={`${API_BASE_URL}${item.icon}`} alt={item.name}/></i>
                                 <span class="cat-title">{item.name}</span>
                              </div>
                           </div>
                        </li>
                        )}
                    
                     </ul>
                     
                  </div>
          <HomeBanner />
          <section class="sa-comman-section addprobtnrow">
          {loggedIn ?   <a href="javascript:void(0);" class="addproductsection open-popup" data-popup-id="AddProduct" 
                            onClick={() => {
                              setRootCategoryId(1);
                              setRootType('home');}} >
                     <span class="para-text">It's time to sell</span>
                     <span class="btn btn-primary " >
                     <img src="data:image/png;base64,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" class="pluseico" alt="Swop"/>  <span > Post an AD</span></span>
                  </a>
            :
            <a href="javascript:void(0);" class="addproductsection open-popup"  data-popup-id="LogIn"
                title={"Login / Register"}>
                     <span class="para-text">It's time to sell</span>
                     <span class="btn btn-primary " >
                     <img src="data:image/png;base64,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" class="pluseico" alt="Swop"/>  <span > Post an AD</span></span>
                  </a>}
</section>

  {dashboard.exclusive_member_deals &&
            dashboard.exclusive_member_deals.length > 0 && (
              <section className="sa-comman-section">
                <div className="sa-heading-section">
                  <h2 className="sa-title">Member<span>&nbsp;Deals</span></h2>
                <Link
                  to="/listing/byCategory/shop-exclusive"
                  className="sa-view"
                  onClick={() =>
                    localStorage.setItem("listingFilterType", "exclusiveMemberDeals")
                  }
                >
                View All
                </Link>
                  <div className="clear"></div>
                </div>
                <div className="sa-fpc-wrap">
                  <div className="default-carousel-simple">
                    {dashboard.exclusive_member_deals.map((card, index) => (
                      <Cards
                        key={index}
                        image={card.image}
                        title={card.title}
                        price={card.price}
                        currency={card.currency}
                        slug={card.slug}
                        cardtype={"product"}
                        priceAboveTitle
                        priceWithDecimals
                        sellerType={card.seller_type}
                      />
                    ))}
                  </div>
                </div>
              </section>
            )}
  <section className="sa-comman-section">
 <ul className="sa-about-slider dealercat">
  <Slider {...settings}>
    {[...(dashboard?.dealership_categories ?? [])]
      .sort((a, b) => (a.order_number ?? 0) - (b.order_number ?? 0))
      .map((item) => (
        <div className="home-item category-new-item" key={item.posted_product_id}>
          <li
            className="col-sm-4"
            onClick={() => {
              localStorage.setItem("categoryname", item.title);
              localStorage.setItem("categoryslug", item.slug);
            }}
          >
            <Link to={`/listing/automobile/${item.slug}`}>
              <i className="iconimg">
                {item.image ? (
                  <img
                    src={`${API_BASE_URL}${item.image}`}
                    alt={item.title}
                    style={{ width: "100%" }}
                  />
                ) : (
                  <img
                    src="/img/no-image-icon-6.png"
                    alt="No image"
                    style={{ width: "100%" }}
                  />
                )}
              </i>

              <span className="securecontent">
                <span className="securehead">{item.title}</span>
              </span>
            </Link>
          </li>
        </div>
      ))}
  </Slider>
</ul>
</section>

 

          <section className="sa-comman-section">
            <div className="sa-heading-section">
              <h2 className="sa-title">
                Shop Dealership<span>&nbsp;Cars</span>
              </h2>
              {/* <a href="/list" className="sa-view"> */}
              <Link to={`/listing/automobile/dealership`} className="sa-view">
                View All
              </Link>
           
              {/* </a> */}
              <div className="clear"></div>
            </div>
            <div className="sa-fpc-wrap">
              <div id="swopcafetown" className="default-carousel-simple">
                {cardDataVehical &&
                  cardDataVehical.map((card, index) => (
                    <Cards
                      key={index}
                      image={card.image}
                      title={card.name}
                      price={card.price}
                      cardtype={'automobile'}
                     kmcontent={card.city}
                     kms_driven={card.kms_driven}
                     fuel_type={card.fuel_type}
                     transmission_type={card.year}
                      slug={card.slug}
                      type={card.type}
                      type_product={card.type_product}
                      POA={card.POA}
                    />
                  ))}
              </div>
            </div>
          </section>
          <section className="sa-comman-section">
            <div className="sa-heading-section">
              <h2 className="sa-title">
                Listings In<span>&nbsp;{dashboard.city_name}</span>
              </h2>
              {/* <a href="/list" className="sa-view"> */}
              <Link to={`/listing/byCity/${""}`} className="sa-view">
                View All
              </Link>
              {" "}
              {/* <i>
                <img src="../img/viewonmap.png" alt="map" />
              </i>{" "} */}
              {/* </a> */}
              <div className="clear"></div>
            </div>
            <div className="sa-fpc-wrap">
              <div id="swopcafetown" className="default-carousel-simple">
                {cardDataSwopTown &&
                  cardDataSwopTown.map((card, index) => (
                    <Cards
                      key={index}
                      image={card.image}
                      title={card.title}
                      kmcontent={card.distance_text}
                      slug={card.slug}
                      cardtype={'product'}
                    />
                  ))}
              </div>
            </div>
          </section>
       
         
        </div>
      </div>
      <div className="container">
        {dashboard.web_home_banner && (
          <div className="sa-add-banner">
            <a
              href={`${dashboard.web_home_banner.web_top_adv_banner.url}`}
              className="sa-inside-add"
              target="_blank"
            >
              <img
                src={`${API_BASE_URL}${dashboard.web_home_banner.web_top_adv_banner.image}`}
                alt="add"
              />
            </a>
          </div>
        )}
        <section className="sa-comman-section sa-feature-pro-sec">
          <div className="sa-heading-section">
            <h2 className="sa-title">
              <span>Featured</span> &nbsp;Listings
            </h2>

            <Link to={`/listing/latest/1`} className="sa-view">
              View All <i className="icon-01"></i>
            </Link>

            <div className="clear"></div>
          </div>
          <div className="sa-fpc-wrap">
            <div className="default-carousel-simple">
              {cardDataFeatured &&
                cardDataFeatured.map((card, index) => (
                  <Cards
                    key={index}
                    image={card.image}
                    title={card.title}
                    kmcontent={card.distance_text}
                    slug={card.slug}
                    cardtype={'product'}
                    featured={card.is_featured_dashboard}
                  />
                ))}
            </div>
          </div>
        </section>
        {/* <section className="sa-comman-section sa-feature-pro-sec">
          <div className="sa-heading-section">
            <h2 className="sa-title">
              <span>Featured</span> Skills & Services
            </h2>
            <Link to={`/listing/latest/2`} className="sa-view">
              View All <i className="icon-01"></i>
            </Link>
            <div className="clear"></div>
          </div>
          <div className="sa-fpc-wrap">
            <div className="default-carousel-simple">
              {cardDataSkillServices &&
                cardDataSkillServices.map((card, index) => (
                  <Cards
                    key={index}
                    image={card.image}
                    title={card.title}
                    kmcontent={card.distance_text}
                    slug={card.slug}
                    cardtype={'product'}
                  />
                ))}
            </div>
          </div>
        </section> */}
        <section className="sa-comman-section sa-tranding-cate">
          <div className="sa-heading-section">
            <h2 className="sa-title">
              Trending<span>&nbsp;Categories</span>
            </h2>
            {/* <a href="" className="sa-view">
              View All <i className="icon-01"></i>{" "}
            </a> */}
            <div className="clear"></div>
          </div>
          <TrendingCategories />
        </section>
        {dashboard.web_home_banner && (
          <div className="sa-add-banner">
            <a
              href={`${dashboard.web_home_banner.web_mid_adv_banner.url}`}
              className="sa-inside-add"
              target="_blank"
            >
              <img
                src={`${API_BASE_URL}${dashboard.web_home_banner.web_mid_adv_banner.image}`}
                alt="add"
              />
            </a>
          </div>
        )}
        <section className="sa-comman-section sa-featured-services">
          <div className="sa-heading-section">
            <h2 className="sa-title">
              <span>About</span> &nbsp;SellAnything{" "}
            </h2>
            {/* <a href="" className="sa-view">
              How it Work’s <i className="icon-01"></i>{" "}
            </a> */}
            <div className="clear"></div>
          </div>
          <HowWorksSld />
        </section>

        {dashboard.web_home_banner && (
          <div className="sa-add-banner">
            <a
              href={`${dashboard.web_home_banner.web_bottom_adv_banner.url}`}
              className="sa-inside-add"
              target="_blank"
            >
              <img
                src={`${API_BASE_URL}${dashboard.web_home_banner.web_bottom_adv_banner.image}`}
                alt="add"
              />
            </a>
          </div>
        )}

       
      </div>
       <SignIn />
       <SignUp />
       {roottype == 'home' ? <AddProductPage rootCategoryId={rootCategoryId} /> : ''}
    </main>
  );
};
export default Home;
